import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { articles } from '@/mocks/articles';

export default function ArticleList() {
  return (
    <>
      <Navbar />
      <main className="pt-16">
        <div className="bg-background-50 border-b border-background-200/70">
          <div className="max-w-7xl mx-auto px-4 md:px-6 py-6">
            <nav className="flex items-center gap-2 text-sm text-foreground-500 mb-4">
              <a href="/" className="hover:text-primary-600 transition-colors">首页</a>
              <i className="ri-arrow-right-s-line"></i>
              <span className="text-foreground-900 font-medium">最新资讯</span>
            </nav>
            <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-2">
              最新资讯
            </h1>
            <p className="text-sm text-foreground-500">
              影视动态、综艺热点、行业观察，一手资讯尽在掌握
            </p>
          </div>
        </div>

        <div className="max-w-7xl mx-auto px-4 md:px-6 py-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {articles.map((article) => (
              <a
                key={article.id}
                href={`/article/${article.id}`}
                className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/50 hover:scale-[1.02] transition-all duration-300 cursor-pointer"
              >
                <div className="aspect-[16/9] overflow-hidden">
                  <img
                    src={article.cover}
                    alt={article.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                </div>
                <div className="p-5">
                  <span className="inline-block px-2.5 py-0.5 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-3">
                    {article.category}
                  </span>
                  <h2 className="text-base font-heading font-semibold text-foreground-900 mb-2 line-clamp-2 leading-snug group-hover:text-primary-600 transition-colors">
                    {article.title}
                  </h2>
                  <p className="text-sm text-foreground-500 line-clamp-2 leading-relaxed mb-4">
                    {article.summary}
                  </p>
                  <div className="flex items-center justify-between text-xs text-foreground-400">
                    <span className="flex items-center gap-2">
                      <i className="ri-calendar-line"></i>
                      {article.date}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line"></i>
                      {article.views.toLocaleString()} 阅读
                    </span>
                  </div>
                </div>
              </a>
            ))}
          </div>
        </div>

        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'CollectionPage',
          name: '最新资讯 - 91在线观看',
          description: '影视动态、综艺热点、行业观察，一手资讯尽在掌握',
          isPartOf: { '@type': 'WebSite', name: '91在线观看', url: 'https://www.91zaixianguankan.com/' },
          breadcrumb: {
            '@type': 'BreadcrumbList',
            itemListElement: [
              { '@type': 'ListItem', position: 1, name: '首页', item: 'https://www.91zaixianguankan.com/' },
              { '@type': 'ListItem', position: 2, name: '最新资讯', item: 'https://www.91zaixianguankan.com/article' },
            ],
          },
        }) }} />
      </main>
      <Footer />
    </>
  );
}